var phone_number = {};
module['exports'] = phone_number;
phone_number.formats = require("./formats");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_CA/phone_number/index.js
 ** module id = 396
 ** module chunks = 0
 **/